<template>
<!-- eslint-disable max-len -->
<div class="starbox" :class="{ green }">
  <div v-for="n in starsArray" :key="n" class="starbox-star">
  </div>
</div>
</template>

<script>
export default {
  props: {
    stars: { type: Number, default: 0 },
    green: { type: Boolean, default: false },
  },
  computed: {
    starsArray() {
      return [...Array(Math.round(this.stars)).keys()];
    },
  },
};
</script>

<style lang="scss" scoped>
.starbox {
  z-index: 1;
  width: 100px;
  height: 40px;
  background-image: url('/static/reports/starbox.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 0px 4px 4px;
}
.starbox.green {
  background-image: url('/static/reports/starboxgreen.png');
}
.starbox-star {
  width: 20%;
  height: 100%;
  background-image: url('/static/reports/star.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin: 0 0 0 10%;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/StarBox.vue